<app-header-simple></app-header-simple>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Slide 1 -->
        <div class="carousel-item active">
            <div class="carousel-container mt-5 animate__animated animate__faster animate__fadeInDown" *ngIf="!isLoading" style="height: 100%;">

                <h2>{{quiniela.titulo}}</h2>
                <p>{{quiniela.descripcion}}</p>

                <div class="row">
                    <div class="col">
                        <h4 style="font-size: 36px;color: #ef6603;font-weight: 600;margin-bottom: 0px;">
                            {{quiniela.precio}}<sub>{{quiniela.moneda}}</sub>
                        </h4>
                        <p style='font-family: "Poppins", sans-serif;text-transform: uppercase;font-weight: 700;'>Precio</p>
                    </div>
                    <div class="col">
                        <div class="vl"></div>
                    </div>
                    <div class="col">
                        <h4 style="font-size: 36px;color: #ef6603;font-weight: 600;margin-bottom: 0px;">
                            {{quiniela.pote}}<sub>{{quiniela.moneda}}</sub>
                        </h4>
                        <p style='font-family: "Poppins", sans-serif;text-transform: uppercase;font-weight: 700;'>Pote</p>
                    </div>
                </div>

                <a (click)="participar()" *ngIf="!quiniela.empezada" class="btn-get-started">Participar en la Quiniela</a>

                <div class="d-flex flex-row">
                    <div style="height: 50px;margin-top: 6px;" *ngIf="!quiniela.empezada">
                        <ng-lottie [options]="Flecha" (animationCreated)="animationCreated($event)"></ng-lottie>
                    </div>
                    <div><a routerLink="/tabla/{{ quiniela.$key }}" class="btn-get-started">Ver puntuación</a></div>
                    <div style="height: 50px;transform: rotate(180deg);margin-top: 7px;" *ngIf="!quiniela.empezada">
                        <ng-lottie [options]="Flecha" (animationCreated)="animationCreated($event)"></ng-lottie>
                    </div>
                </div>


            </div>
            <div class="carousel-container mt-5 animate__animated animate__faster animate__fadeInDown" *ngIf="isLoading" style="height: 100%;">
                <app-loader></app-loader>
            </div>

        </div>
    </div>

    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
    <defs>
      <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
    </defs>
    <g class="wave1">
      <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
    </g>
    <g class="wave2">
      <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
    </g>
    <g class="wave3">
      <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
    </g>
  </svg>
</section>
<!-- End Hero -->

<!-- ======= F.A.Q Section ======= -->
<section id="faq" class="faq">
    <div class="container">

        <div class="section-title" data-aos="zoom-out">
            <h2>F.A.Q</h2>
            <p>PREGUNTAS FRECUENTES</p>
        </div>

        <ul class="faq-list">

            <li data-aos="fade-up" data-aos-delay="100">
                <a data-toggle="collapse" class="" href="#faq1">¿Qué es una QUINIELA? <i class="icofont-simple-up"></i></a>
                <div id="faq1" class="collapse show" data-parent=".faq-list">
                    <p>
                        Juego de apuestas en el cual los participantes rellenan un formulario con los pronósticos de los resultados de cierta competición deportiva, enfocado especialmente en partidos de fútbol. En la medida que acierten resultados van acumulando puntos, al final
                        el premio se entrega al o a los participantes con el mayor puntaje obtenido.
                    </p>
                </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="200">
                <a data-toggle="collapse" href="#faq2" class="collapsed">¿ Con qué finalidad se realiza un QUINIELA? <i
            class="icofont-simple-up"></i></a>
                <div id="faq2" class="collapse" data-parent=".faq-list">
                    <p>
                        El objetivo principal es divertirse entre amigos y conocidos, pero también podemos recaudar fondos para alguna acción benéfica que requiera obtener ayuda monetaria y en algunos casos para recabar fondos para realizar alguna compra o reparación comunitaria,
                        ejemplo: reparar canchas deportivas, reparar ascensores, etc.
                    </p>
                </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="300">
                <a data-toggle="collapse" href="#faq3" class="collapsed">¿ Cómo puedo participar ? <i
            class="icofont-simple-up"></i></a>
                <div id="faq3" class="collapse" data-parent=".faq-list">
                    <p>
                        Participar es muy sencillo, los organizadosres le enviaran una invitación con el link de la QUINIELA, debe llenar el formulario y realizar el pago respectivo.
                    </p>
                </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="400">
                <a data-toggle="collapse" href="#faq4" class="collapsed">¿ Debo revisar los datos de los organizadores y la
          motivación? <i class="icofont-simple-up"></i></a>
                <div id="faq4" class="collapse" data-parent=".faq-list">
                    <p>
                        Es importante chequear la información de los organizadores, conocer y tener alguna referencia de los motivos para los cuales se está realizando la QUINIELA.
                    </p>
                </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="500">
                <a data-toggle="collapse" href="#faq5" class="collapsed">¿ Cómo obtengo puntos al finalizar cada partido ? <i
            class="icofont-simple-up"></i></a>
                <div id="faq5" class="collapse" data-parent=".faq-list">
                    <p>
                        La puntuación es muy sencilla, por cada partido se pueden obtener máximo 3 puntos. Si acierta el resultado exacto, usted se gana 3 puntos; si usted no acierta el resultado pero en sus pronóstico acierta el equipo ganador obtiene 1 punto. Si el resultado
                        queda en EMPATE y usted colocó que terminaria en empate, pero su resultado no es el exacto, usted gana solo 1 punto. En casos de partidos APLAZADOS o SUSPENDIDOS sin resultado oficial, se esperará hasta la fecha del último partido
                        de la quiniela, si para ese día no se ha realizado quedará fuera de la quiniela, sin aportar puntos a ningún participante.
                    </p>
                </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="600">
                <a data-toggle="collapse" href="#faq6" class="collapsed">¿ Cómo se sabe cual será el monto a repartir ? <i
            class="icofont-simple-up"></i></a>
                <div id="faq6" class="collapse" data-parent=".faq-list">
                    <p>
                        En todo momento la pagina de la quiniela mostrará el POTE, que es el premio a entregar a la persona que acumulo mas puntos al finalizar el ultimo partido especificado en la quiniela. Es importante recalcar que se pudiera dar el caso que dos o mas personas
                        queden con la misma cantidad de puntos en el primer lugar, en estos casos se reparte el POTE entre estos ganadores.
                    </p>
                </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="700">
                <a data-toggle="collapse" href="#faq7" class="collapsed">¿ Cómo se sabe cuantos puntos llevo acumulado
          y cómo estoy dentro del cuadro de participantes ? <i class="icofont-simple-up"></i></a>
                <div id="faq7" class="collapse" data-parent=".faq-list">
                    <p>
                        Después de llenar y pagar la QUINIELA, la página te mostrará el botón VER PUNTUACION. Al pulsarlo aparecerá en pantalla la tabla de puntuación y además una línea para realizar busqueda por nombre.
                    </p>
                </div>
            </li>

        </ul>

    </div>
</section>
<!-- End F.A.Q Section -->